import Config from '../config/config';
import axios from 'axios';

const { baseURL } = Config.API;

// New axios instance for refreshTokens - allow to ignore interceptors
const tokenInstance = axios.create({ baseURL });

const signInByEmail = async (formData) => {
  return tokenInstance({
    method: 'POST',
    baseURL,
    url: '/auth/loginByEmail',
    data: formData
  });
};

const logout = async () => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/auth/logout'
  });
};

const refreshTokens = async (refreshToken) => {
  return tokenInstance({
    method: 'GET',
    url: '/auth/refreshTokens',
    headers: {
      Authorization: `Bearer ${refreshToken}`
    }
  });
};

export default {
  signInByEmail,
  refreshTokens,
  logout
};
